"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.498 8.505v4.152h.997v-3.68A4.51 4.51 0 0 0 12.5 4.502 4.508 4.508 0 0 0 7.996 0a4.507 4.507 0 0 0-4.5 4.502h.997A3.508 3.508 0 0 1 7.996.998a3.509 3.509 0 0 1 3.505 3.504 3.508 3.508 0 0 1-3.505 3.504.499.499 0 0 0-.498.499ZM8.034 16a.789.789 0 1 0 0-1.578.789.789 0 0 0 0 1.578Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.406 12.732v6.312h1.125v-5.773a6.656 6.656 0 0 0 6.085-6.624A6.655 6.655 0 0 0 11.97 0a6.655 6.655 0 0 0-6.65 6.647h1.125a5.529 5.529 0 0 1 5.523-5.522 5.529 5.529 0 0 1 5.522 5.522 5.529 5.529 0 0 1-5.522 5.522.563.563 0 0 0-.563.563Zm.619 11.168a.973.973 0 1 0 0-1.947.973.973 0 0 0 0 1.947Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.209 16.976v8.416h1.5v-7.697c4.538-.382 8.113-4.197 8.113-8.832C24.822 3.976 20.846 0 15.959 0 11.07 0 7.095 3.976 7.095 8.863h1.5c0-4.06 3.303-7.363 7.364-7.363 4.06 0 7.363 3.303 7.363 7.363 0 4.06-3.303 7.363-7.363 7.363a.75.75 0 0 0-.75.75Zm.824 14.89a1.298 1.298 0 1 0 0-2.595 1.298 1.298 0 0 0 0 2.596Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.062 26.405v13.209h1.875V27.31c7.104-.483 12.735-6.416 12.735-13.64C37.672 6.134 31.538 0 24 0S10.328 6.133 10.328 13.672h1.875c0-6.505 5.292-11.797 11.797-11.797 6.505 0 11.797 5.292 11.797 11.797 0 6.504-5.292 11.796-11.797 11.796a.938.938 0 0 0-.938.937Zm1.055 21.475a1.672 1.672 0 1 0 0-3.344 1.672 1.672 0 0 0 0 3.344Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30.75 35.207v17.611h2.5V36.415c9.471-.645 16.979-8.555 16.979-18.186C50.229 8.177 42.051 0 32 0 21.949 0 13.771 8.177 13.771 18.229h2.5C16.271 9.556 23.327 2.5 32 2.5c8.673 0 15.729 7.056 15.729 15.729 0 8.672-7.056 15.728-15.729 15.728-.69 0-1.25.56-1.25 1.25Zm1.407 28.633a2.23 2.23 0 1 0-.002-4.459 2.23 2.23 0 0 0 .002 4.46Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconQuestionMark = function IconQuestionMark(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Question Mark' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "QuestionMark"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconQuestionMark.sizes = [16, 24, 32, 48, 64];
IconQuestionMark.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconQuestionMark;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/QuestionMark.js
// module id = 1831
// module chunks = 0